import axios from "axios";
import { useState, useEffect } from "react";

function Dump() {
  return (
    <div className="App">
      <h1>Image uploading react</h1>
      <img src="http://localhost:8585/view/assembly.png" alt="something" style={{width:"200px"}} />
      <a href="http://localhost:8585/view/resume.pdf" target="new"> See Resume</a>
    </div>
  )
}

export default Dump;